import { render } from "./ElectionVoteView.vue?vue&type=template&id=535e47e7&scoped=true"
import script from "./ElectionVoteView.vue?vue&type=script&lang=js"
export * from "./ElectionVoteView.vue?vue&type=script&lang=js"

import "./ElectionVoteView.vue?vue&type=style&index=0&id=535e47e7&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535e47e7"]])

export default __exports__